<template>
	<footer class="footer-section">
		<div class="container">
			<div class="row" style="padding-bottom: 0;">
				<div class="custom-flexbox">
					<div class="col-sm-2 custom-width">
						<h5 class="title-sm">
							<a v-link="{ path: '/' }">Lasddi</a>
						</h5>
						<ul class="footer-list">
							<li>
								<a v-link="{ path: '/acerca'}">
									Quienes somos
								</a>
							</li>
							<li>
								<a href="https://proyectos.lasddi.com/" target="_blank" >
									Proyectos Contract
								</a>
							</li>
						</ul>
					</div>
					<div class="col-sm-2 custom-width">
						<h5 class="title-sm">Servicio al cliente</h5>
						<ul class="footer-list">
							<li>
								<a v-link="{ path: '/privacidad'}">
									Aviso de privacidad
								</a>
							</li>
							<li>
								<a v-link="{ path: '/terminos-y-condiciones'}">
									Términos y condiciones
								</a>
							</li>
						</ul>
					</div>
					<div class="col-sm-2 custom-width">
						<h5 class="title-sm">Catálogo</h5>
						<div class="col-sm-7 no-padding">
							<ul class="footer-list">
								<li>
									<a v-link="{ path: '/almacenamiento?page=1' }" @click="resetFilters(1)">
										Almacenamiento
									</a>
								</li>
								<li>
									<a v-link="{ path: '/sillas?page=1' }" @click="resetFilters(6)">
										Sillas
									</a>
								</li>
								<li>
									<a v-link="{ path: '/mesas?page=1' }" @click="resetFilters(12)">
										Mesas
									</a>
								</li>
								<li>
									<a v-link="{ path: '/salas?page=1' }" @click="resetFilters(19)">
										Salas
									</a>
								</li>
							</ul>
						</div>
						<div class="col-sm-5 no-padding">
							<ul class="footer-list">
								<li>
									<a v-link="{ path: '/lamparas?page=1' }" @click="resetFilters(26)">
										Lámparas
									</a>
								</li>
								<li>
									<a v-link="{ path: '/accesorios?page=1' }" @click="resetFilters(30)">
										Accesorios
									</a>
								</li>
								<li>
									<a v-link="{ path: '/novedades?page=1' }" @click="resetFilters(0)">
										Novedades
									</a>
								</li>
								<li>
									<a v-link="{ path: '/especiales?page=1' }" @click="resetFilters(0)">
										Especiales
									</a>
								</li>
							</ul>
						</div>
					</div>
					<div class="col-sm-2 custom-width">
						<h5 class="title-sm"><a v-link="{ path: '/preguntas-frecuentes' }">FAQ</a></h5>
						<ul class="footer-list">
							<li>
								<a href="/terminos-y-condiciones#politica-de-devoluciones">
									Devoluciones
								</a>
							</li>
							<li>
								<a href="/sistema-envios" target="_blank">
									Sistema de envíos
								</a>
							</li>
							<li>
								<a href="/terminos-y-condiciones#pagos-de-productos">
									Pagos
								</a>
							</li>
							<li>
								<a href="/terminos-y-condiciones#garantia-de-mercancia">
									Garantías
								</a>
							</li>
							<!-- <li>
								<a href="" v-link="{ path: '/preguntas-frecuentes' }">
									Descuentos
								</a>
							</li> -->
						</ul>
					</div>
					<div class="col-sm-2">
			            <h5 class="title-sm">
			            	<a v-link="{ path: '/contacto'}" target="_top">
			            		Contáctanos
			            	</a>
			            </h5>
			            <ul class="footer-list">
			                <li>
			                  <a v-link="{ path: '/contacto#mensaje' }">
			                  	Déjanos un mensaje
			                  </a>
			                </li>
			                <li>
			                  <a v-link="{ path: '/contacto#contacto' }">
			                  	hola@lasddi.com
			                  </a>
			                </li>
			                <li>
			                  <a href="https://wa.me/523327482493" target="_blank">
													(33) 2748 2493
			                  </a>
			                </li>
			            </ul>
			      	</div>
				</div>
			</div>
		</div>

		<div class="container">
			<div class="row validation" style="padding-top: 0;">
				<div class="col-sm-4 icon-center">
					<h5 class="title-sm">Métodos de pago</h5>
					<img src="../images/visa.png" alt="visa">
					<img src="../images/master-card.png" alt="mastercard">
					<img src="../images/american-express.png" alt="american-express">
					<img src="../images/paypal.png" alt="paypal">
					<img src="../images/spei.png" alt="spei">
				</div>
				<div class="col-sm-3 icon-center">
					<h5 class="title-sm">Envíos</h5>
					<img src="../images/paqueteexpress.svg" alt="fedex">
			        <img class="pointer" data-toggle="modal" data-target="#modal-shipping" src="../images/info-sm.png" alt="info">

          			<modal-shipping></modal-shipping>
				</div>
				<div class="col-sm-2">
					<h5 class="title-sm">Verificación</h5>
					<img id="trustwaveSealImage" src="https://sealserver.trustwave.com/seal_image.php?customerId=bfb32dcae0e74590957e3abf838a5837&amp;size=105x54&amp;style=invert" border="0" style="cursor:pointer;" onclick="javascript:window.open('https://sealserver.trustwave.com/cert.php?customerId=bfb32dcae0e74590957e3abf838a5837&amp;size=105x54&amp;style=invert', 'c_TW', 'location=no, toolbar=no, resizable=yes, scrollbars=yes, directories=no, status=no, width=615, height=720'); return false;" oncontextmenu="javascript:alert('Copying Prohibited by Law - Trusted Commerce is a Service Mark of TrustWave Holdings, Inc.'); return false;" alt="This site is protected by Trustwave's Trusted Commerce program" title="This site is protected by Trustwave's Trusted Commerce program">
				</div>
				<div class="col-sm-2 icon-center text-right">
					<h5 class="title-sm">Redes sociales</h5>
					<div class="social-icons">
						<a href="https://www.facebook.com/lasddi/" target="_blank">
							<i class="fa fa-facebook fa-fw" aria-hidden="true"></i>
						</a>
						<a href="https://twitter.com/lasddi" target="_blank">
							<i class="fa fa-twitter fa-fw" aria-hidden="true"></i>
						</a>
						<a href="https://www.instagram.com/lasddi/" target="_blank">
							<i class="fa fa-instagram fa-fw" aria-hidden="true"></i>
						</a>
						<a href="https://pinterest.com/lasddi/" target="_blank">
							<i class="fa fa-pinterest fa-fw" aria-hidden="true"></i>
						</a>
					</div>
				</div>
			</div>
		</div>

		<div class="container">
			<div class="row">
				<div class="col-sm-12">
					<p class="footer-credits">LASDDI® 2016 Todos los derechos reservados. Prohibida la reproducción parcial o total de logotipos, imágenes y fotografías sin autorización previa del sitio.
					</p>
				</div>
			</div>
		</div>
	</footer>
</template>

<style scoped>



</style>

<script>
import ModalShipping from './Modals/Modal-shipping.vue';
import {
	resetColors,
	getColors,
	resetFilterPrice
} from '../store/actions';

export default {
	vuex: {
		actions: {
			resetColors,
			resetFilterPrice,
			getColors
		}
	},
	components: {
		ModalShipping
	},
	methods: {
		resetFilters (same_cat) {
			this.resetColors();
			this.resetFilterPrice();
			let cat = null;

			switch (this.$route.name) {
				case 'almacenamiento':
					cat = 1;
					break;
				case 'sillas':
					cat = 6;
					break;
				case 'mesas':
					cat = 12;
					break;
				case 'salas':
					cat = 19;
					break;
				case 'lamparas':
					cat = 26;
					break;
				case 'accesorios':
					cat = 30;
					break;
			}

			if (cat == same_cat) {
				this.resetColors();
				this.getColors(cat);
			}

			this.getColors(cat);
			$('.sub-filters').prop('checked', false);
		},
	}
}
</script>



// WEBPACK FOOTER //
// Footer.vue?1abcedcc